import React from "react"
import { ModulosFornecedorContextProvider } from "./context/ModulosFornecedorContextProvider"
import { ModulosFornecedor } from "./ModulosFornecedor"

export function Index() {
    return (
        <ModulosFornecedorContextProvider>
            <ModulosFornecedor />
        </ModulosFornecedorContextProvider>
    )
}
